import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { iMessageSquare, iLock } from '@hover/icons';

export const INSURANCE_BETTER_WAY_TO_BUILD_CAROUSEL_DATA = [
  {
    img: (
      <StaticImage
        placeholder="blurred"
        alt="phone"
        objectFit="contain"
        src="../assets/images/insurance-screen1.png"
      />
    ),
    body: 'Follow the prompt in the text your insurer sent you to download the HOVER app.',
    index: 0,
    icon: iMessageSquare,
  },
  {
    img: (
      <StaticImage
        placeholder="blurred"
        alt="phone"
        objectFit="contain"
        src="../assets/images/insurance-screen2.png"
      />
    ),
    body: 'Set up your account and secure it with a password.',
    index: 1,
    icon: iLock,
  },
];

export const INSURANCE_BETTER_WAY_TO_BUILD_CAROUSEL_DATA_MOBILE = [
  {
    img: (
      <StaticImage
        placeholder="blurred"
        alt="phone"
        objectFit="contain"
        width={270}
        src="../assets/images/invited_by_insurance_slide_1.png"
      />
    ),
    body: 'Follow the prompt in the text your insurer sent you to download the HOVER app.',
    index: 0,
    icon: iMessageSquare,
  },
  {
    img: (
      <StaticImage
        placeholder="blurred"
        alt="phone"
        objectFit="contain"
        width={270}
        src="../assets/images/invited_by_insurance_slide_2.png"
      />
    ),
    body: 'Set up your account and secure it with a password.',
    index: 1,
    icon: iLock,
  },
];
